import { defineStore } from 'pinia'
import EntradaMercancia from '../services/entradaMercancia'
const _EntradaMercancia = new EntradaMercancia()
export const useHistorialStore = defineStore('useHistorialStore', {
  state: () => {
    return {
      count: 0,
      rows: [],
      limit: 10,
      offset: 0,
      pageOptions: [2, 10, 20, 30, 50, 100],
      filter: {
        fechaInicio: null,
        fechaFin: null,
        numeroEnvio: null,
        numeroGuia: null
      }
    }
  },
  getters: {
    _count: (state) => state.count,
    _rows: (state) => state.rows,
    _limit: (state) => state.limit,
    _offset: (state) => state.offset,
    _pageOptions: (state) => state.pageOptions
  },
  actions: {
    listar () {
      const params = {
        limit: this.limit,
        offset: this.offset,
        ...this.filter
      }
      _EntradaMercancia.listar(params).then(({ data }) => {
        this.rows = data.rows
        this.count = data.count
      })
    }
  }
})
